import { MaSignupHeaderClasses, MyAccountTheme } from '@dxp-module/themes'
import { makeStyles } from '@mui/styles'

const headerStyles = makeStyles<MyAccountTheme, object, MaSignupHeaderClasses>(
  theme => ({
    root: {
      marginBottom: theme.spacing(4),
    },
    title: {},
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    message: {
      color: theme.palette.error.main,
    },
    formTitle: {},
    labelAsterisk: {},
  }),
  { name: 'MyAccount_Signup_Header' }
)

export default headerStyles
